import { render, staticRenderFns } from "./SubscriptionPlanView.vue?vue&type=template&id=bc70fb8e&scoped=true&"
import script from "./SubscriptionPlanView.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPlanView.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionPlanView.vue?vue&type=style&index=0&id=bc70fb8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc70fb8e",
  null
  
)

export default component.exports